export const convertToCommaString = (num) => {
    num = Math.abs(num);
    if (num < 1000) return `${num}`;
    let commaString = `,${`${num % 1000}`.padStart(3, "0")}`;
    num = Math.floor(num / 1000);
    while (num > 99) {
        commaString = `,${`${num % 100}`.padStart(2, "0")}${commaString}`;
        num = Math.floor(num / 100);
    }
    return `${num}${commaString}`;
};